import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const SpinnerRect = props => (
  <div className={classNames('spinner-rect', props.className)}>
    <div className="rect1" />
    <div className="rect2" />
    <div className="rect3" />
    <div className="rect4" />
    <div className="rect5" />
  </div>
);

SpinnerRect.propTypes = {
  className: PropTypes.string,
};

SpinnerRect.defaultProps = { className: '' };

export default SpinnerRect;
